<template>
  <div style="padding: 0 35px">
    <div class="goodsParame">
      <div :key="index" v-for="(item, index) in sku_prop">
        <!-- 名称 -->
        <div class="add_item_specs">
          <div style="color: #777777;margin-right: 10px;">规格名</div>
          <el-autocomplete class="inline-input" v-model="item.name" :fetch-suggestions="querySearch" placeholder="请输入内容"
            @select="handleSelect(item, $event)">
            <template slot-scope="{ item }">
              <div v-if="!isShow">{{ item.name }}</div>
              <div v-else style="color: #409EFF;" @click="newAddSpecs(item)">
                <i class="el-icon-plus"></i>
                <span>点击新建：</span>
                <span>{{ item.name }}</span>
              </div>
            </template>
          </el-autocomplete>
          <div style="color: #409EFF;margin-left: 6px;" @click="deletName(item, index)">删除</div>
        </div>
        <!-- 值 -->
        <div>
          <!-- 原有属性值 -->
          <div>
            <el-checkbox-group v-model="sku_prop[index].value" @change="checkgroup">
              <el-checkbox v-for="(res, ind) in item.values" :key="ind" @change="checkSpecs" :label="res"></el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- 要新增值 -->
          <div style="overflow: auto;margin: 20px 0;">
            <div style="margin-right: 10px;float: left;line-height: 40px;">
              规格值:
            </div>
            <div :key="specsIndex" v-for="(newSpecsItem, specsIndex) in item.newSpecObj"
              style="float: left;display: flex;">
              <el-input disabled v-model="item.newSpecObj[specsIndex]" placeholder="请输入内容" type="text">
                <el-popconfirm @confirm="deletSpecsClick(item, newSpecsItem, specsIndex)" slot="append"
                  confirm-button-text='确定' cancel-button-text='取消' icon="el-icon-info" icon-color="red"
                  title="确定删除该属性值吗?">
                  <el-button style="color: #409EFF;" slot="reference">删除</el-button>
                </el-popconfirm>
              </el-input>
            </div>
            <div style="float: left;">
              <el-popover ref="popoverRef" placement="right" width="350" trigger="click">
                <div style="display: flex;align-items: center;">
                  <el-select v-model="item.newSpecsList" multiple filterable allow-create default-first-option
                    placeholder="请选择规格值">
                  </el-select>
                  <div style="margin-left: 20px;">
                    <!-- <el-button size="mini">取消</el-button> -->
                    <el-button size="mini" type="primary" @click="confirmSpecs(item)">确定</el-button>
                  </div>
                </div>
                <div slot="reference" style="line-height: 40px;color: #409EFF;cursor: pointer;"><i
                    class="el-icon-plus">添加规格值</i></div>
              </el-popover>
            </div>
          </div>
        </div>
      </div>
      <el-button icon="el-icon-plus" @click="addParamClick" size="mini">添加规格</el-button>
    </div>
    <!-- sku列表 -->
    <div v-if="baseGoodsData.skus.length != 0">
      <el-table :data="baseGoodsData.skus" style="width: 100%">
        <el-table-column align="center" :key="item.id" :label="item.name" v-for="(item, index) in tableHead">
          <template slot-scope="scope">
            {{ scope.row.ownSpecObj[index].value }}
          </template>
        </el-table-column>
        <el-table-column width="200" label="重量(kg)" align="center">
          <template slot-scope="scope">
            <div class="inpBox">
              <el-input v-model="scope.row.weight"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="skuCode" width="200" label="sku编码" align="center">
          <template slot-scope="scope">
            <div class="inpBox">
              <el-input v-model="scope.row.skuCode"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="阶梯价格" align="center">
          <el-table-column label="起订量(≥)" width="120" align="center">
            <template slot-scope="scope">
              <div class="inpBox" :key="priceIndex" v-for="(res, priceIndex) in scope.row.pricePropList">
                <el-input v-model="res.qty"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="zip" label="价格(单价)" width="200" align="center">
            <template slot-scope="scope">
              <div class="inpBox" style="display: flex;" :key="priceIndex"
                v-for="(res, priceIndex) in scope.row.pricePropList">
                <el-input v-model="res.price" style="width: 150px;"></el-input>
                <div style="font-size: 30px;">
                  <i v-if="res.priceType == 'add'" @click="addPriceClick(scope.row.pricePropList)"
                    class="el-icon-circle-plus-outline"></i>
                  <i v-else class="el-icon-remove-outline"
                    @click="reducePriceClick(scope.row.pricePropList, priceIndex)"></i>
                </div>

              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import {
  addSpecsName,
  getCustomSpecs,
  addSpecsData,
  deletSpecsData
} from "@/request/api/goods";
let _this;
export default {
  props: ["baseGoodsData", "skusData"],
  data() {
    return {
      tableHead: [],
      newSpecsId: 0,//解决新添加的规格名直接添加值
      isShow: false,
      specsNameList: [],
      sku_prop: [], //处理basGoodsData多选框无法选择问题
      skus: []
    };
  },
  watch: {
    sku_prop: {
      handler: function (val) {
        this.baseGoodsData.skuPropsObj = val  //待提交的商品sku组合
        // 是否有新加的sku规格和规格值
        //待处理---->  newSpecObj
        let skus = []
        console.log('有没有', _this.sku_prop)
        if (_this.getArrayByArrays(_this.sku_prop).length != 0) {
          console.log('又好吃啦', _this.sku_prop)
          _this.getArrayByArrays(val).forEach(item => {
            if (contains(_this.skusData, item)) {
              _this.skusData.forEach(itemm => {
                if (itemm.skuName == item) {
                  skus.push(itemm)
                }
              })
            } else {
              let obj_sku = {
                ownSpecObj: _this.getOwnSpecObj(_this.sku_prop, item),
                pricePropList: [{ qty: 0, price: 0, priceType: "add" }],
                skuCode: "",
                weight: '',
                skuName: item
              }
              skus.push(obj_sku)
            }
          })
        }
        _this.baseGoodsData.skus = skus
      },
      deep: true,
    },
    baseGoodsData: {
      handler: function (val) {
        console.log('这是规格页', val)
        if (val.skus.length != 0) {
          this.tableHead = val.skus[0].ownSpecObj
        }
        if (val.skuPropsObj) {
          this.sku_prop = val.skuPropsObj
        }
      },
      deep: true,
    },
    'baseGoodsData.skuPropList'(val) {
      this.specsNameList = []
      this.specsNameList = val.concat(this.baseGoodsData.customSpecsList)
    },
    'baseGoodsData.customSpecsList'(val) {
      this.specsNameList = []
      this.specsNameList = val.concat(this.baseGoodsData.skuPropList)
    }
  },
  created() {
    _this = this;
  },
  methods: {
    deletName(item, index) {
      this.sku_prop.splice(index, 1)
      if (item.name) {
        this.specsNameList.push(item)
      }
    },
    addPriceClick(e) {
      let obj = {
        price: 0,
        priceType: "reduce",
        qty: 0
      }
      e.push(obj)
      this.$forceUpdate()
    },
    reducePriceClick(e, ind) {
      e.splice(ind, 1)
      this.$forceUpdate()
    },
    deletSpecsClick(e, value, index) {
      _this.sku_prop.forEach(item => {
        if (item.id == e.id) {
          item.value.splice(item.value.indexOf(e), 1)
        }
      })
      e.newSpecObj.splice(index, 1)
      deletSpecsData({ propId: e.id, propValue: value }).then(res => {
        console.log(res)
      })
      this.$forceUpdate()
    },
    getConcatArr() {
      getCustomSpecs(1).then(res => {
        console.log(res)
        // 获取自定义的规格
        this.baseGoodsData.customSpecsList = res.data
      })
    },
    // 点击新增规格值
    confirmSpecs(e) {
      addSpecsData({
        id: e.id ? e.id : _this.newSpecsId, specsPropsValues: e.newSpecsList
      }).then(res => {
        e.newSpecsList.forEach(item => {
          e.newSpecObj.push(item)
        })
        e.newSpecsList = []
        this.sku_prop.forEach(item => {
          if (e.id == item.id) {
            item.value = item.value.concat(e.newSpecObj)
          }
        })
        _this.$message({ message: res.msg, type: 'success' })
        _this.getConcatArr()
        _this.$forceUpdate()
        _this.newSpecsId = 0
        this.$refs.popoverRef[0].doClose()
        console.log(this.$refs.popoverRef)
      })
    },
    newAddSpecs(e) {
      addSpecsName({ name: e.name, propType: 1 }).then(res => {
        console.log(res)
        let obj = {
          value: [],
          name: e.name,
          id: res.data
        }
        _this.newSpecsId = res.data
        this.specsNameList.push(obj)
        // _this.getConcatArr()
      })
      console.log(e)
    },
    handleSelect(item, e) {
      console.log(item)
      item.value = []
      item.name = e.name
      item.id = e.id
      for (var i = 0; i < this.specsNameList.length; i++) {
        if (item.id == this.specsNameList[i].id) {
          this.specsNameList.splice(i, 1)
        }
      }
      item.values = e.specsPropsValues
    },
    querySearch(queryString, cb) {
      var restaurants = this.specsNameList
      if (restaurants.filter(this.createFilter(queryString)).length == 0) {
        cb([{ name: queryString }]);
        this.isShow = true
      } else {
        this.isShow = false
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }

    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    checkgroup(e) {
      console.log(e)
    },
    checkSpecs(e) {
      this.$forceUpdate()
      console.log(e)
    },
    addParamClick() {
      let obj = { name: '', id: 0, newSpecObj: [], value: [] }
      this.sku_prop.push(obj)
    },
    reduceSybol(e, index) {
      e.splice(index, 1);
      this.$forceUpdate();
    },
    addSymbol(e) {
      console.log(e);
      let price_obj = {
        qty: 0,
        price: 0,
        priceType: "reduce",
      };
      e.push(price_obj);
      this.$forceUpdate();
    },
    // 封装每组sku的ownSpecObj
    getOwnSpecObj(arr, skuName) {
      let ownSpec = [];
      let nameList = skuName.split("|");
      nameList.forEach((item) => {
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < arr[i].value.length; j++) {
            if (item == arr[i].value[j]) {
              let obj = {
                id: arr[i].id,
                name: arr[i].name,
                value: item,
              };
              ownSpec.push(obj);
            }
          }
        }
      });
      this.tableHead = ownSpec//单独处理表头
      return ownSpec;
    },
    getArrayByArrays(arrays) {
      var arr = [""];
      for (var i = 0; i < arrays.length; i++) {
        arr = _this.getValuesByArray(arr, arrays[i].value);
      }
      return arr;
    },
    getValuesByArray(arr1, arr2) {
      var arr = [];
      for (var i = 0; i < arr1.length; i++) {
        var v1 = arr1[i];
        for (var j = 0; j < arr2.length; j++) {
          var v2 = arr2[j];
          var value;
          if (v1 == "") {
            value = v2;
          } else {
            value = v1 + "|" + v2;
          }
          arr.push(value);
        }
      }
      return arr;
    },
  },
};
function contains(arr, val) {
  return arr.some(item => item.skuName === val);
}
// function combinationArr(newArrData) {
//   let len = newArrData.length;
//   // 当数组长度大于等于2时
//   if (len >= 2) {
//     // 第一个数组的长度
//     let len1 = newArrData[0].length;
//     // 第二个数组的长度
//     let len2 = newArrData[1].length;
//     //  申明一个新数组,做数据暂存
//     let items = new Array();
//     // 申明新数组的索引
//     let index = 0;
//     // 2层嵌套循环,将组合放到新数组中
//     for (var i = 0; i < len1; i++) {
//       for (var j = 0; j < len2; j++) {
//         if (items.length < index + 1) {
//           items.push([])
//         }
//         if (newArrData[0][i] instanceof Array) {
//           items[index] = items[index].concat(newArrData[0][i].concat(newArrData[1][j]));
//         } else {
//           items[index] = items[index].concat([newArrData[0][i], newArrData[1][j]]);
//         }
//         index++;
//       }
//     }
//     // 将新组合的数组并到原数组中
//     let newArr = new Array(len - 1);
//     for (let i = 2; i < newArrData.length; i++) {
//       newArr[i - 1] = newArrData[i];
//     }
//     newArr[0] = items;
//     // 执行回调
//     return combinationArr(newArr);
//   } else {
//     return newArrData[0];
//   }
// }
</script>
<style lang="scss" scoped>
.inpBox /deep/ .el-input__inner {
  height: 30px;
  line-height: 30px;
}

/deep/ .el-checkbox {
  width: 250px;
  margin-top: 10px;
}

.add_item_specs {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
}

.goodsParame {
  background-color: #f8f8f8;
  padding: 10px 20px;
}

.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}




.pub_content /deep/ .el-checkbox {
  width: 200px;
}

.input_box {
  width: 300px;
  border: 1px solid #eeeeee;
  padding: 10px 5px;

}

.pub_price_box {
  display: flex;
  align-items: center;
  // justify-content: space-around;
}

.pub_bax {
  color: #333333;
  font-size: 15px;

  .pub_title {
    font-weight: 600;
    font-size: 16px;
  }

  .pub_line {
    display: flex;
    align-items: center;
    // flex-wrap: wrap;
    padding: 6px 0;

    .pub_width {
      width: 90px;
      // flex: 1;
      text-align: left;
    }
  }

  .price_center {
    width: 150px;
    text-align: center;
    padding-left: 0;
    padding-right: 0;
    margin: 0 20px;
  }

  .pub_content {
    padding: 20px 35px;
  }

  .goods_attr {
    width: 70%;
  }
}
</style>